import { Component, NgModule, Output, Input, EventEmitter, ViewChild, ElementRef, AfterViewInit, OnDestroy, output, ChangeDetectorRef } from '@angular/core';
import { DxTreeViewModule, DxTreeViewComponent, DxTreeViewTypes } from 'devextreme-angular/ui/tree-view';
import { navigation } from '../../../app-navigation';
import { KeycloakService } from 'keycloak-angular';

import * as events from 'devextreme/events';
import { jwtDecode } from 'jwt-decode';
import { EventObject } from 'devextreme/events';

@Component({
  selector: 'side-navigation-menu',
  templateUrl: './side-navigation-menu.component.html',
  styleUrls: ['./side-navigation-menu.component.scss']
})
export class SideNavigationMenuComponent implements AfterViewInit, OnDestroy {
  @ViewChild(DxTreeViewComponent, { static: true })
  menu!: DxTreeViewComponent;

  @Output()
  selectedItemChanged = new EventEmitter<DxTreeViewTypes.ItemClickEvent | null>();

  @Output()
  openMenu = new EventEmitter<any>();

  private _selectedItem!: String;
  @Input()
  set selectedItem(value: String) {
    this._selectedItem = value;
    if (!this.menu.instance) {
      return;
    }
    this.menu.instance.selectItem(value.replace('/',''));
  }


  private _items!: Record <string, unknown>[];
  private _keycloakService! : KeycloakService
  private _RolesArray! : Array<String>;
    
  get items() {

    if (!this._items) 
    {
      
      this._items = navigation.map((item) => {

        if(item.path && !(/^\//.test(item.path))){
          item.path = `/${item.path}`;
        }
        return { ...item, expanded: !this._compactMode }
      });
      
      this._keycloakService.getToken().then((token)=> {
      
        this._RolesArray = jwtDecode(token)['sitenav'] as Array<String>;
        
      }).finally(()=>{
        this._items =  this.items.filter( (navItem) =>
          { 
              if(navItem.hasOwnProperty('role') && (this._RolesArray != undefined)){
                
                //if has children
                if(navItem.hasOwnProperty('items') && Array.isArray(navItem['items']) && this._RolesArray.includes((navItem['role'] as string)))
                {
                   navItem['items'] = navItem['items'].filter((subnavItem)=> {
                    if(subnavItem.hasOwnProperty('role')){
                      return this._RolesArray.includes((subnavItem['role'] as string));
                    }
                    return false;
                  })
                  
                }
                return this._RolesArray.includes((navItem['role'] as string));
              }  
              return false; 
          });
          
      });
    }
    return this._items;
  }

  private _compactMode = false;
  @Input()
  get compactMode() {
    return this._compactMode;
  }
  set compactMode(val) {
    this._compactMode = val;

    if (!this.menu.instance) {
      return;
    }

    if (val) {
      this.menu.instance.collapseAll();
    } else {
      this.menu.instance.expandItem(this._selectedItem);
    }
  }

  constructor(private elementRef: ElementRef, private keycloak : KeycloakService, private cdref : ChangeDetectorRef)
  {
    this._keycloakService = keycloak;
  }

  onItemClick(event: DxTreeViewTypes.ItemClickEvent) {

    this.selectedItemChanged.emit(event);
  }

  ngAfterViewInit(){
    events.on(this.elementRef.nativeElement, 'dxclick', (e: Event) => {
      this.openMenu.next(e);
    });
    
  }

  ngOnDestroy() {
    events.off(this.elementRef.nativeElement, 'dxclick');
  }


}

@NgModule({
  imports: [ DxTreeViewModule ],
  declarations: [ SideNavigationMenuComponent ],
  exports: [ SideNavigationMenuComponent ]
})
export class SideNavigationMenuModule { }
